var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('the-navigation-bar',{staticClass:"navigation"}),_c('v-main',{staticClass:"content-container"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }